import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Header from "../../components/Header/Header";
import Bottom from "../../components/Bottom/Bottom";
import {
  HeaderContainer,
  Logo,
  LogoFont,
  Video,
  VideoContainer,
} from "./style";

import mainVideo from "../../assets/Home/mainVideo.mp4";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}

const Home = () => {
  const size = useWindowSize();

  return (
    <>
      <HeaderContainer>
        <Logo as={Link} to="/" aria-label="홈으로 이동">
          <LogoFont>D E L I G H T &nbsp; F I L M</LogoFont>
        </Logo>
        <Header />
      </HeaderContainer>
      <VideoContainer $height={size.height}>
        <Video $desktop muted autoPlay loop playsInline>
          <source src={mainVideo} type="video/mp4" />
        </Video>
        <Video $mobile muted autoPlay loop playsInline>
          <source src={mainVideo} type="video/mp4" />
        </Video>
      </VideoContainer>
      <Bottom />
    </>
  );
};

export default Home;
